// Local Storage Auth Store
export const LOCAL_STORAGE_AUTH_KEY = "growsari-auth";
export const LOCAL_STORAGE_ACCOUNT_PROFILE = "growsari-account-profile";
export const SESSION_STORAGE_IS_STORE_PROFILE_COMPLETED = "growsari-is-store-profile-completed";
export const SESSION_STORAGE_IS_DATA_AND_PRIVACY_ACCEPTED = "growsari-is-data-and-privacy-accepted";
export const LOCAL_STORAGE_IS_FROM_PRESIGNUP_FLOW = "growsari-is-from-pre-signup-flow";
export const LOCAL_STORE_DONE_SIGN_UP = "done-signup";

export const LOCAL_STORAGE_APP_DATA_VERSION = "app-data-version";
export const LOCAL_STORAGE_CLIENT_UUID = "client-uuid";
export const LOCAL_SECURITY_QEUSTION_ANSWERED = "growsari-security-question-answered";
export const LOCAL_STORAGE_NATIVE_DEVICE_ID = "native-device-id";
export const LOCAL_STORAGE_MERCHANTS_CURRENCY = "merchants-currency-array";

export const APP_DATA_VERSION = "1";
